module.exports = __webpack_public_path__ + "img/bars.d46e0d58.svg";